var _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    width: "100%",
    height: "100%",
    viewBox: "0 0 1465 384",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Logo",
    x: 0,
    y: 0,
    width: 1464.75,
    height: 384,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 105.534,
    cy: 192,
    r: 105.534
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.424,178.022l30.326,0l0,-30.75l27.569,0l0,30.75l30.325,0l0,27.956l-30.325,0l0,30.75l-27.569,0l0,-30.75l-30.326,0l0,-27.956Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M291.576,201.876l-0.274,0l0,38.683l-31.824,0l0,-97.118l31.686,0l0,35.802l0.275,0l25.925,-35.802l38.408,0l-36.487,44.444l38.271,52.674l-40.055,0l-25.925,-38.683Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.76,243.302c-7.59,0 -14.197,-1.051 -19.821,-3.155c-5.624,-2.103 -10.311,-4.984 -14.06,-8.642c-3.749,-3.657 -6.538,-7.978 -8.367,-12.962c-1.829,-4.984 -2.744,-10.357 -2.744,-16.118l0,-58.984l32.647,0l0,55.418c0,4.663 1.12,8.298 3.361,10.905c2.24,2.606 5.418,3.909 9.533,3.909c4.115,0 7.293,-1.303 9.534,-3.909c2.24,-2.607 3.36,-6.242 3.36,-10.905l0,-55.418l32.51,0l0,58.984c0,5.761 -0.983,11.134 -2.949,16.118c-1.966,4.984 -4.87,9.305 -8.711,12.962c-3.84,3.658 -8.619,6.539 -14.334,8.642c-5.716,2.104 -12.368,3.155 -19.959,3.155Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.448,143.441l41.837,0c4.756,0 9.488,0.48 14.198,1.44c4.709,0.961 8.916,2.652 12.619,5.076c3.704,2.423 6.699,5.67 8.985,9.739c2.286,4.069 3.429,9.168 3.429,15.295c0,5.944 -1.463,11.179 -4.389,15.706c-2.926,4.527 -7.133,8.024 -12.62,10.494l24.691,39.368l-37.585,0l-18.655,-34.705l-0.961,0l0,34.705l-31.549,0l0,-97.118Zm31.275,41.015l6.447,0c1.098,0 2.309,-0.092 3.635,-0.275c1.326,-0.183 2.561,-0.571 3.704,-1.166c1.143,-0.594 2.103,-1.417 2.88,-2.469c0.778,-1.051 1.166,-2.446 1.166,-4.184c0,-1.737 -0.32,-3.109 -0.96,-4.115c-0.64,-1.006 -1.463,-1.76 -2.469,-2.263c-1.006,-0.503 -2.103,-0.823 -3.292,-0.96c-1.189,-0.137 -2.286,-0.206 -3.292,-0.206l-7.819,0l0,15.638Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.411,143.441l34.705,0l37.859,97.118l-35.527,0l-5.076,-14.266l-30.863,0l-4.801,14.266l-34.567,0l38.27,-97.118Zm16.873,33.882l-7.956,24.005l15.774,0l-7.818,-24.005Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 674.834,
    y: 143.441,
    width: 32.921,
    height: 97.118,
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.098,185.69l1.509,54.869l-30.452,0l0,-97.118l42.66,0l17.558,52.263l0.686,0l15.226,-52.263l44.032,0l0,97.118l-31.686,0l0.96,-54.595l-0.823,-0.137l-18.107,54.732l-23.045,0l-17.832,-54.869l-0.686,0Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.424,143.441l66.803,0l0,27.16l-36.077,0l0,8.368l33.882,0l0,25.376l-33.882,0l0,9.054l38.408,0l0,27.16l-69.134,0l0,-97.118Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.138,240.559l0,-97.118l36.214,0c7.681,0 15.02,0.755 22.016,2.264c6.996,1.508 13.168,4.115 18.518,7.818c5.35,3.704 9.625,8.619 12.826,14.746c3.2,6.127 4.801,13.855 4.801,23.182c0,8.505 -1.532,15.867 -4.596,22.085c-3.063,6.218 -7.155,11.317 -12.276,15.295c-5.122,3.978 -11.02,6.927 -17.696,8.847c-6.675,1.921 -13.625,2.881 -20.85,2.881l-38.957,0Zm31.413,-69.409l0,41.426l6.035,0c7.682,0 13.58,-1.669 17.696,-5.007c4.115,-3.338 6.172,-8.802 6.172,-16.392c0,-6.31 -2.057,-11.225 -6.172,-14.746c-4.116,-3.521 -9.603,-5.281 -16.461,-5.281l-7.27,0Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1089.23,
    y: 143.441,
    width: 32.921,
    height: 97.118,
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.87,192c0,-7.773 1.372,-14.815 4.115,-21.124c2.744,-6.31 6.493,-11.706 11.248,-16.187c4.756,-4.481 10.357,-7.933 16.804,-10.356c6.447,-2.424 13.329,-3.635 20.644,-3.635c7.499,0 14.586,1.211 21.262,3.635c6.676,2.423 12.254,5.692 16.735,9.808l-20.027,24.142c-1.829,-2.378 -4.115,-4.184 -6.859,-5.418c-2.743,-1.235 -5.807,-1.852 -9.19,-1.852c-2.744,0 -5.304,0.48 -7.682,1.44c-2.378,0.96 -4.458,2.355 -6.241,4.184c-1.783,1.829 -3.178,4.046 -4.184,6.653c-1.006,2.606 -1.509,5.509 -1.509,8.71c0,3.201 0.526,6.058 1.578,8.573c1.051,2.515 2.469,4.687 4.252,6.516c1.783,1.829 3.864,3.223 6.241,4.184c2.378,0.96 4.893,1.44 7.545,1.44c3.749,0 6.973,-0.777 9.67,-2.332c2.698,-1.555 4.824,-3.384 6.379,-5.487l20.027,24.005c-4.39,4.39 -9.785,7.888 -16.186,10.494c-6.402,2.606 -13.672,3.909 -21.811,3.909c-7.315,0 -14.197,-1.234 -20.644,-3.703c-6.447,-2.469 -12.048,-5.967 -16.804,-10.494c-4.755,-4.527 -8.504,-9.922 -11.248,-16.186c-2.743,-6.264 -4.115,-13.237 -4.115,-20.919Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.11,143.441l34.705,0l37.859,97.118l-35.528,0l-5.075,-14.266l-30.864,0l-4.801,14.266l-34.567,0l38.271,-97.118Zm16.872,33.882l-7.956,24.005l15.775,0l-7.819,-24.005Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.53,143.441l32.921,0l0,69.135l32.235,0l0,27.983l-65.156,0l0,-97.118Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c59f676cc8ea3ef881298f2394cf7b00.svg";
export { ForwardRef as ReactComponent };